import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import authValidationMessages from "./locales/ua/auth-validation-messages.json";
import blocks from "./locales/ua/blocks.json";
import errors from "./locales/ua/errors.json";
import filters from "./locales/ua/filters.json";
import footer from "./locales/ua/footer.json";
import forgotpassword from "./locales/ua/forgotpassword.json";
import group from "./locales/ua/group.json";
import groups from "./locales/ua/groups.json";
import header from "./locales/ua/header.json";
import metrics from "./locales/ua/metrics.json";
import onboarding from "./locales/ua/onboarding.json";
import overview from "./locales/ua/overview.json";
import person from "./locales/ua/person.json";
import research from "./locales/ua/research.json";
import resetpassword from "./locales/ua/resetpassword.json";
import signin from "./locales/ua/signin.json";
import slices from "./locales/ua/slices.json";
import stats from "./locales/ua/stats.json";

export const resources = {
  ua: {
    signin,
    forgotpassword,
    resetpassword,
    onboarding,
    stats,
    metrics,
    groups,
    footer,
    header,
    slices,
    authValidationMessages,
    filters,
    errors,
    blocks,
    group,
    research,
    overview,
    person,
  },
} as const;

export const defaultNS = "signin";

void i18n.use(initReactI18next).init({
  compatibilityJSON: "v3",
  resources,
  lng: "ua",
  ns: Object.keys(resources.ua),
  defaultNS,
  interpolation: { escapeValue: false },
});

export default i18n;
